import axios from "axios";
import Config from "src/config";

const v2_actionCriarTreinamentoUpload = (agentId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${agentId}/trainings/upload`,
        data
    });
};

export default v2_actionCriarTreinamentoUpload;
